import { __assign, __rest } from "tslib";
import React, { cloneElement, forwardRef } from 'react';
import useFixMobileSafariScrollBounce from '../hocs/fixMobileSafariScrollBounce';
import styles from './ScrollableArea.module.css';
import { ScrollbarContainer, Scrollbars, useScrollbars, } from '../containers/Scrollbars';
var IOSScrollContainer = forwardRef(function (_a, ref) {
    var isScrollable = _a.isScrollable, children = _a.children;
    var _b = useFixMobileSafariScrollBounce({
        ref: ref,
        isScrollable: isScrollable,
    }), onTouchStart = _b.onTouchStart, onTouchMove = _b.onTouchMove;
    var bounceFixedScrollableArea = cloneElement(children, {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
    });
    return bounceFixedScrollableArea;
});
var DesktopScrollContainer = forwardRef(function (_a, ref) {
    var width = _a.width, height = _a.height, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight, paddingTop = _a.paddingTop, paddingBottom = _a.paddingBottom, children = _a.children;
    var _b = useScrollbars({
        containerRef: ref,
        containerWidth: width,
        containerHeight: height - paddingTop - paddingBottom,
        contentWidth: imageWidth,
        contentHeight: imageHeight - paddingTop - paddingBottom,
        allowedDirections: 'vertical',
        containerLeft: 0,
        containerTop: paddingTop,
        scrollbars: true,
    }), onContainerScroll = _b.onContainerScroll, scrollbarProps = __rest(_b, ["onContainerScroll"]);
    var enhancedFixedScrollableArea = cloneElement(children, {
        onScroll: function (e) {
            if (children.props.onScroll) {
                children.props.onScroll(e);
            }
            onContainerScroll(e);
        },
    });
    return (React.createElement(React.Fragment, null,
        enhancedFixedScrollableArea,
        ref.current && imageHeight > height && (React.createElement(Scrollbars, __assign({}, scrollbarProps)))));
});
export default function ScrollableArea(_a) {
    var children = _a.children, width = _a.width, height = _a.height, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight, onScroll = _a.onScroll, _b = _a.padding, paddingTop = _b.paddingTop, paddingBottom = _b.paddingBottom, isMobile = _a.isMobile, withRef = _a.withRef, id = _a.id, screenID = _a.screenID, isRecording = _a.isRecording, isScrollable = _a.isScrollable, isIOS = _a.isIOS;
    var baseComponent = (React.createElement(ScrollbarContainer, { className: styles.scrollable, id: id, onScroll: isRecording
            ? function (e) {
                if (e.target !== withRef.current)
                    return;
                onScroll(e.target.scrollLeft, e.target.scrollTop, screenID);
            }
            : undefined, ref: withRef, style: { width: width, height: height, paddingTop: paddingTop } }, children));
    if (isIOS) {
        return (React.createElement(IOSScrollContainer, { isScrollable: isScrollable, ref: withRef }, baseComponent));
    }
    if (isMobile) {
        return baseComponent;
    }
    // Desktop
    return (React.createElement(DesktopScrollContainer, { height: height, imageHeight: imageHeight, imageWidth: imageWidth, paddingBottom: paddingBottom, paddingTop: paddingTop, ref: withRef, width: width }, baseComponent));
}
